import type { ICalendarEvent } from '@/features/calendar/interfaces'
import type { TCalendarView } from '@/features/calendar/types'

import { Columns, Grid3X3, List, Plus } from 'lucide-react'

import { Button, ButtonGroup } from '@/components/ui/button'
import { CreateEventDialog } from '@/features/calendar/components/dialogs/add-event-dialog'
import { DateNavigator } from '@/features/calendar/components/header/date-navigator'
import { TodayButton } from '@/features/calendar/components/header/today-button'

import { useCalendar } from '../../contexts/use-calendar'

interface IProps {
  view: TCalendarView
  data: ICalendarEvent[]
}

export function CalendarHeader({ view, data }: IProps) {
  const { setView, canManageEvents } = useCalendar()

  return (
    <div className="flex flex-col gap-4 border-b p-4 lg:flex-row lg:items-center lg:justify-between">
      <div className="flex items-center gap-3">
        <TodayButton />
        <DateNavigator view={view} data={data} />
      </div>
  
      <div className="flex flex-col items-center gap-1.5 sm:flex-row sm:justify-between">
        <div className="flex w-full items-center gap-1.5">
          <ButtonGroup>
            <Button aria-label="View by day" onClick={() => setView('day')}>
              <List />
            </Button>

            <Button aria-label="View by week" className="hidden md:flex" onClick={() => setView('week')}>
              <Columns />
            </Button>

            <Button aria-label="View by month" onClick={() => setView('month')}>
              <Grid3X3 />
            </Button>
          </ButtonGroup>
        </div>

        {canManageEvents && (
          <CreateEventDialog>
            <Button size="sm" className="w-full sm:w-auto">
              <Plus />
              Create Event
            </Button>
          </CreateEventDialog>
        )}
      </div>
    </div>
  )
}
